// extracted by mini-css-extract-plugin
export default {"resizer":"JobsTableCell_resizer__joCAo","isResizing":"JobsTableCell_isResizing__+d5-A","headerCell":"JobsTableCell_headerCell__1QWSH"};